import * as React from "react";
import * as _ from "underscore";
import { connect } from "react-redux";
import { Button } from "carbon-components-react";
import { CloudDownload24 } from "@carbon/icons-react";

import HurdleView from "underwriter_dashboard/shared/HurdleView";
import APIClient from "web_modules/APIClient";
import { AppShape, HurdleShape, DocTypes } from "@eave/shared/types/api";
import DocDisplay from "../shared/DocDisplay";
import DocEntry from "../shared/DocEntry";
import { getOldestDocOfType, getSortedDocsOfType } from "../shared";
import { loadApp } from "../actions";

// TODO: jjw: very similar to HazardInsuranceEditor; refactor as one

/* FloodCertificationEditor */

interface HurdleEditorProps {
  dispatch?: Function;
  app: AppShape;
  hurdle: HurdleShape;
  onHide: Function;
}

class FloodCertificationEditor extends React.Component<HurdleEditorProps, any> {
  constructor(props) {
    super(props);
    this.state = {
      valid_flood_zones: null,
    };
  }

  componentDidMount() {
    APIClient.get(`/uw/flood_zones`).then((response: Object) => {
      this.setState({ valid_flood_zones: response });
    });
  }

  reloadApp = () => {
    loadApp(this.props.dispatch, this.props.app.id);
  };

  requestFloodCert = () => {
    if (!confirm("Are you sure you want to trigger a new FloodCert order?")) {
      return;
    }
    APIClient.get(`/uw/${this.props.app.id}/trigger_flood_cert_order`).then(({ found }) => {
      if (found) {
        setTimeout(() => {
          this.reloadApp();
        }, 3000);
      }
      alert(
        `FloodCert response is "in research" and will be available later. Please retry request in one business day.`,
      );
    });
  };

  docHasValuesEntered(docType, sectionKey) {
    const doc: any = getOldestDocOfType(this.props.app.documents, docType);
    if (!doc || !doc.sections) return false;

    const section: any = _.findWhere(doc.sections, { section_key: sectionKey });
    if (!section || !section.fields) return false;

    return _.any(_.map(section.fields, (f: any) => f.field_value));
  }

  renderMessageModal(text) {
    const { app, hurdle, onHide } = this.props;

    const filteredDocs: any = getSortedDocsOfType(app.documents, DocTypes.FloodCertificate);

    return (
      <HurdleView app={app} hurdle={hurdle} onHide={onHide}>
        <p style={{ marginBottom: "1rem" }}>{text}</p>
        <Button
          kind="tertiary"
          style={{ marginBottom: 20 }}
          onClick={this.requestFloodCert}
          renderIcon={CloudDownload24}
        >
          Request FloodCert
        </Button>
        {filteredDocs && filteredDocs.length ? (
          <div style={{ height: "calc(100% - 40px)" }} className="floodcert-hurdle">
            <DocDisplay docs={filteredDocs} />
          </div>
        ) : null}
      </HurdleView>
    );
  }

  render() {
    const { app, hurdle, onHide } = this.props;
    const { flood_zone_identifier, flood_insurance_required } = this.props.app;
    const { valid_flood_zones } = this.state;

    // cf. populateFloodZoneInsuranceInfo() in golang
    if (!flood_zone_identifier) {
      return this.renderMessageModal("Waiting on FloodCert for info on purchased property.");
    }
    if (flood_zone_identifier && flood_insurance_required === null) {
      return this.renderMessageModal(
        "Error! FloodCert info obtained, but SFHA flag and flood zone are not consistent.",
      );
    }
    if (
      flood_zone_identifier &&
      valid_flood_zones &&
      !valid_flood_zones.includes(flood_zone_identifier)
    ) {
      return this.renderMessageModal(
        `
          Flood zone identifier "${flood_zone_identifier}" is not a valid flood zone identifier.
          "NO", indicating not in a flood zone, will be disclosed.
        `,
      );
    }
    if (flood_zone_identifier && flood_insurance_required === false) {
      return this.renderMessageModal("Purchased property not in a flood zone; no action needed.");
    }

    // N.B. from here on down: (flood_zone_identifier !== ""),
    // and (flood_insurance_required === true)

    if (!getOldestDocOfType(this.props.app.documents, DocTypes.FloodPolicy)) {
      return this.renderMessageModal("Waiting for borrower(s) to upload their policy.");
    }

    return (
      <HurdleView app={app} hurdle={hurdle} onHide={onHide}>
        <DocEntry {...this.props} docType={DocTypes.FloodPolicy} docNotFoundMsg="not reached" />
      </HurdleView>
    );
  }
}

export default connect()(FloodCertificationEditor);
